import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Pack después de comprar?',
  a: 'Al completar tu pago recibís un mail automático con el acceso inmediato a todos los módulos y bonos en formato PDF digital. En menos de 5 minutos ya estás adentro.'
}, {
  q: '¿Sirve si hace mucho que no entreno?',
  a: 'Sí. El Pack está diseñado exactamente para eso. El Módulo 1 arranca desde tu punto de partida real, sin importar cuánto tiempo pasó desde la última vez que entrenaste.'
}, {
  q: '¿Necesito ir a un gimnasio o puedo hacerlo en casa?',
  a: 'Todos los módulos tienen versión casa y versión gym. Con mancuernas básicas o tu propio peso corporal es suficiente para arrancar.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 3 bonos estratégicos están incluidos en ambas ofertas sin costo adicional.'
}, {
  q: '¿Sirve si nunca hice HYROX ni sé bien cómo funciona?',
  a: 'Perfecto para vos. El Tomo 5 del Pack Total te explica exactamente cómo funciona una carrera HYROX, cómo inscribirte y cómo llegar preparada.'
}, {
  q: '¿En cuánto tiempo puedo llegar a mi primera carrera HYROX?',
  a: 'Con constancia y el sistema correcto, en 8 a 12 semanas ya podés estar lista para tu primera carrera. El Pack te da el mapa completo.'
}, {
  q: '¿Qué diferencia tiene con videos gratis de Instagram?',
  a: 'Los videos de Instagram te dan tips sueltos. Este Pack te da un sistema progresivo completo, con planificación, seguimiento, nutrición y estrategia de carrera. Todo en un solo lugar y diseñado para tu vida real.'
}, {
  q: '¿Por qué elegir el Pack Total y no el estándar?',
  a: 'El Pack Total agrega los 2 tomos más avanzados: fuerza funcional real y la guía completa para tu primera carrera. Si tu objetivo es cruzar la meta, el Total te lleva hasta ahí.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si abrís el Pack y no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios complicados.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-brand-black" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <div className="text-center mb-16" data-id="element-70">
          <div className="text-brand-copper font-bold tracking-widest uppercase text-sm mb-4" data-id="element-71">
            DUDAS COMUNES
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-display" data-id="element-72">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-73">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-dark border border-gray-800 rounded-xl overflow-hidden" data-id="element-74">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-900 transition-colors" data-id="element-75">
                <span className="text-white font-semibold pr-4" data-id="element-76">{faq.q}</span>
                {openIndex === i ? <MinusIcon className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-77" /> : <PlusIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-78" />}
              </button>
              <AnimatePresence data-id="element-79">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-80">
                    <div className="px-6 pb-5 text-gray-400 text-sm leading-relaxed border-t border-gray-800 pt-4" data-id="element-81">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}